import type { ReactNode } from 'react';

export const symbol_pallet: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M160-120v20q0 12.75-8.62 21.37Q142.75-70 130-70h-20q-12.75 0-21.37-8.63Q80-87.25 80-100v-30q0-12.75 8.63-21.38Q97.25-160 110-160h740q12.75 0 21.38 8.62Q880-142.75 880-130v30q0 12.75-8.62 21.37Q862.75-70 850-70h-20q-12.75 0-21.37-8.63Q800-87.25 800-100v-20H520v20q0 12.75-8.62 21.37Q502.75-70 490-70h-20q-12.75 0-21.37-8.63Q440-87.25 440-100v-20H160Zm70-200q-12.75 0-21.37-8.63Q200-337.25 200-350v-500q0-12.75 8.63-21.38Q217.25-880 230-880h500q12.75 0 21.38 8.62Q760-862.75 760-850v510q0 8.5-5.75 14.25T740-320H230Zm10-40h480v-480H240v480Zm340-300q8.5 0 14.25-6t5.75-14q0-8-5.75-14T580-700H380q-8.5 0-14.25 6T360-680q0 8 5.75 14t14.25 6h200ZM240-360v-480 480Z"
		/>
	</svg>
);
